import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TextField, MenuItem } from '@mui/material';
export function SourceFilterSelect({ value, onChange }) {
    return (_jsxs(TextField, { select: true, size: "small", label: "Source", value: value, onChange: e => onChange(e.target.value), sx: { minWidth: 140, bgcolor: 'white' }, children: [_jsx(MenuItem, { value: "all", children: "All" }), _jsx(MenuItem, { value: "app", children: "Logged in app" }), _jsx(MenuItem, { value: "odoo_import", children: "Imported" })] }));
}
